import React from 'react';
import ProductsSection from './ProductsSection';

const Products = ({ clientId }) => {
  return (
    <div className="products-container">
      <ProductsSection clientId={clientId} />
    </div>
  );
};

export default Products; 